import * as Yup from "yup";
import * as i18nUtils from "./i18n";

const flowTypes = {
    onboarding: "onboarding",
    enrollment: "enrollment",
    associate: "associate",
};

// related with terms and conditions in final step
export const defaultTextCheckboxTermsAndConditions = "Acepto el envío de mis datos personales y uso de credenciales.";
export const defaultTextCheckboxTermsAndConditionsPJ = "Acepto el envío de información y documentación de mi empresa.";
export const defaultTextMigrationEnrolledUserStepFinish1 =
    "¡Felicitaciones! Terminaste el registro como usuario Online Banking";
export const defaultTextMigrationEnrolledUserStepFinish2 =
    "A continuación, iniciá sesión para aceptar los Términos y Condiciones y las Comisiones.";
export const defaultTextMigrationEnrolledUserStepFinish3 =
    "Si tu empresa aún no es cliente de BiBank, continuá con el proceso de alta";

export const defaultTextMigrationPfStepFinishTitle =
    "¡Felicitaciones! Terminaste el registro como usuario Online Banking";

export const defaultTextMigrationPfStepFinishMessage1 =
    "A continuación, iniciá sesión para aceptar los Términos y Condiciones y las Comisiones.";

export const defaultTextMigrationPfStepFinishMessage2 =
    "Si tu empresa aún no es cliente de BiBank, continuá con el proceso de alta";

export const defaultErrorMessageTermsAndConditions = "Requerido";
export const keyErrorMessageTermsAndConditions = "onboarding.term.and.condition.error.validation";
export const getValidationSchemaTermsAndConditions = () =>
    Yup.object().shape({
        termsConditions: Yup.boolean(
            i18nUtils.get(keyErrorMessageTermsAndConditions, defaultErrorMessageTermsAndConditions),
        )
            .required(defaultErrorMessageTermsAndConditions)
            .oneOf([true], defaultErrorMessageTermsAndConditions),
    });

export const TERMS_AND_CONDITIONS_CATEGORY_PF = "acceptTermsAndConditionsPF";
export const TERMS_AND_CONDITIONS_CATEGORY_PJ = "acceptTermsAndConditionsPJ";
export { flowTypes as default };
